export default __webpack_public_path__ + "static/media/NewHampshire.a8980d0c.jpg";